<template>
  <div class="intelligentAgriculture-page">
    <!-- 乡村资源一张图 -->
    <div class="haeder-container blackStatic" style="height:141px;">
        <Header></Header>
        <Nav></Nav>
    </div>
    	<div class="main text-img-box">
			<div class="top-banner" style="position: relative;">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/wuranzhili/wrzlbg.webp">            
            </div>
            <div style="background:#F4F9EF;text-align: center;padding: 60px;position: relative;">
                <div class="wuzhen-title">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuranzhili/nav1.png">
                </div>
                <div style="width: 800px;
    background: rgb(255, 255, 255);
    text-align: justify;
    padding: 40px;
    line-height: 36px;
    color: rgb(51, 51, 51);
    font-size: 20px;
    margin: auto;
    margin-top: 70px;
    margin-bottom: 70px;">
                    <p><span class="text-bg">项目背景</span>浙江大学污染环境修复与生态健康教育部重点实验室合作项目，重金属污染耕地可持续安全利用，浙江大学杨肖娥教授团队2005年入选教育部污染环境修复与生态系统健康创新团队 也是浙江大学生物修复与生态健康科技创新团队和农生环学部创新重团队。在土壤 与水体污染生态修复工程、生物质固废高值资源化循环利用、现代农业与营养健康 等方面形成国内外优势和特色。</p>
                    
                    <img style="width:720px;height:auto;margin-top:20px" src="../../assets/img/caseDetails/wuranzhili/wrzl1.webp">
                </div>
                
            </div>		
            <div class="inside-box" style="padding-top:100px;">
                <div class="wuzhen-title">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuranzhili/nav2.png">
                </div>
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">建设重点</span>
                </div>
                 <p style="text-align: left;padding-left: 48px;margin-bottom: 20px;">高/超积累植物强化提取修复与低积累作物高效避免修复（安全生 产）的有机耦合。衢江区污染农田安全利用PCA+E模式，早-晚稻连作PCA+E；面积-1500亩。</p>
                <div class="img-box">
                    <img style="width:840px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuranzhili/wrzl2.png">
                </div>   
            </div>
            <div style="background:#F4F9EF;padding-top:20px;">
                <div class="wuzhen-title">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuranzhili/nav2.png">
                </div>
                <div class="img-box">
                    <img style="width:1200px;height:auto;margin:auto;margin-top:40px;margin-bottom:40px" src="../../assets/img/caseDetails/wuranzhili/img2.png">
                </div>   
            </div>
            <div class="inside-box" style="padding-top:20px;">
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">主要功能</span>
                </div>
                <div class="img-box">
                    <img style="width:1200px;height:auto;margin:auto;margin-top:40px;margin-bottom:40px" src="../../assets/img/caseDetails/wuranzhili/wrzl6.webp">
                </div>
            </div>
		</div>
        
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
.inside-box{
    width: 1200px;
    margin: auto;
    margin-bottom: 40px;
}
.img-box{
    width: 100%;
}
.inside-nav{
    margin-bottom: 15px;
}
 .haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}








@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img2 {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img2 {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	background: #FCF9FC;
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text {
	width: 460px;
	height: 377px;
	display: flex;
	flex-direction: column;

}

.text-img-box h2 {
	width: 460px;
	height: 45px;
	text-align: right;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(48, 181, 94, 1);
	line-height: 45px;
	margin-top: 25px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: auto;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}
.village-resources-box{
    width: 1000px;
    margin: auto;
    padding: 80px 0;
    position: relative;
}
.village-resources-cbox{
    width: 27%;
    float: left;
    height: 360px;
    margin: 3%;
    background: #fff;
    box-shadow: 0 5px 2px #eaeaea;
    padding: 20px;
}
.village-resources-cbox img{
    width: 100px;
    margin: auto;
}
.village-resources-cbox h4{
    line-height: 58px;
	font-size: 18px;
}
.village-resources-cbox p{
    line-height: 40px;
    font-size: 16px;
} 
.left-line{
position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 80px;
    top: 89px;
}

.right-line{
position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 80px;
    top: 89px;
}




</style>